module.exports = __webpack_public_path__ + "img/AccuASPECTS.fcce6938.png";